import { useContext } from 'react';
import { Redirect, useLocation, useParams } from 'react-router-dom';
import { ApplicantPage } from './ApplicantPage';
import { PublicConfigurationContext } from './Context';

/**
 * This is a wrapper component that is used to wrap the ApplicantPage component.
 * This is required so that the 3 column page doesn't do a full reload when the route changes - 
 * so we can switch between /payments/ and /a/ without losing a call or doing a full refresh of the history and notes tabs.
 */
export function ApplicantRouteWrapper(props: {
  isAdminPanel?: boolean,
  subsurveyPlaceholder?: string,
  mainContentRenderer?: (props: { uid: string }) => React.ReactNode,
  readonly?: boolean
}) {
  const { uid, subsurvey, applicantDash, dynamoAppId, portalPath } = useParams() as Record<string, string>;
  const { pathname, search, hash } = useLocation();
  const publicConfig = useContext(PublicConfigurationContext);
  const searchParams = new URLSearchParams(search);

  if (publicConfig.adminPanelEnabled && !props.isAdminPanel && searchParams.get('legacy') !== 'true') {
    return <Redirect to={`/admin-panel${pathname}${search}${hash}`} />;
  }

  // unsubmitted app alert!!!! don't let them hang out at /a/ !!!
  if (uid && uid.length > 22) {
    const base = props.isAdminPanel ? '/admin-panel' : '';
    return <Redirect to={`${base}/ua/${uid}${subsurvey ? `/${subsurvey}` : ''}${search}${hash}`} />;
  }

  return (
    <ApplicantPage
      uid={uid}
      dynamoAppId={dynamoAppId}
      subsurvey={props.subsurveyPlaceholder ?? subsurvey}
      applicantDash={applicantDash}
      portalPath={portalPath}
      isAdminPanel={!!props.isAdminPanel}
      mainContentRenderer={props.mainContentRenderer}
      readonly={props.readonly} />
  );
}
